import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_sleepwear: FaireCategoryEntity = {
  token: "cat_women-sleepwear",
  type: "category",
  name: "Sleepwear & nightwear",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/sleepwear",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
